import React, { useEffect, useState } from "react";
import "./logSetting.scss";
import { Button, Col, Divider, Input, Row, Select, Typography } from "antd";
import LogSettingForm from "../../../components/logSettingForm/logSettingForm";
import { GetLogPlatformRes } from "../../../interfaces/logPlatform.interface";
import { HandleErrors } from "../../../utils/handleErrors";
import { getAllLogPlatformService } from "../../../services/logPlatform.service";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { GetPermissionRes } from "../../../interfaces/role.interface";

const LogSetting = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<GetLogPlatformRes[]>([]);
  const health = useSelector<RootState, string>((root) => root.app.health);
  

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      if(health == 'license-false'){
        return;
      }
      setLoading(true);
      const res = await getAllLogPlatformService({});
      setData(res.list);
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="LogSetting">
      {health == "license-false" && (
        <div
          style={{
            position: "absolute",
            zIndex: "100000",
            width: "100%",
            height: "100%",
            top: 0,
            right: 0,
            backdropFilter: "blur(3px)",
            backgroundColor: "rgba(255, 255, 255, 0.5)" /* optional tint */,
          }}
        ></div>
      )}
      <Row align={"middle"} justify={"start"} className="title-box">
        <Col>
          <Typography.Text className="title">تنظیمات لاگ</Typography.Text>
        </Col>
      </Row>
      {data.map((item) => (
        <LogSettingForm
          item={item}
          onSubmit={() => {
            getData();
          }}
        />
      ))}
    </div>
  );
};

export default LogSetting;
